<template>
  <div class="member_information_box">
    <div class="member_information_title">个人信息</div>
    <div class="member_information_content clearfix_">
      <div class="mic_pic fl clearfix_">
        <div class="fl mic_pic_box">
          <img :src="pic?pic:timg" alt="">
          <input class="file img_btn" type="file" accept="image/png,image/gif,image/jpeg" @change="uploadMemberUserImg($event)"/>
        </div>
        <!-- <div class="fl mic_pic_username"><input type="text" placeholder="请设置用户名"></div> -->
      </div>
      <div style="width:600px;padding-top:30px;" class="mic_i fl">
        <ul>
          <li class="clearfix_">
            <div class="fl">
              <span style="line-height:42px;">真实姓名：</span>
            </div>
            <input class="fl txt" type="text" v-model="name">
          </li>
          <li class="clearfix_">
            <div class="fl">
              <i>*</i>
              <span style="line-height:42px;">昵称：</span>
            </div>
            <input class="fl txt" type="text" v-model="nickname">
          </li>
          <li style="margin-bottom:0;" class="clearfix_">
            <div class="fl">
              <i>*</i>
              <span>性别：</span>
            </div>
            <input @change="changeInput(1)" :checked="gender==1" class="fl sex" type="radio" name="sex"><span class="fl">男</span>
            <input @change="changeInput(2)" :checked="gender==2" class="fl sex" type="radio" name="sex"><span class="fl">女</span>
          </li>
          <li v-show="userData.isUpdateRole">
            <div class="fl">
              <span style="line-height:40px;">角色：</span>
            </div>
            <ul class="fl information_role clearfix_">
              <li @click="roleMaskShow(item.id)" class="fl" v-for="(item,index) in userData.roleData" :key="index">{{item.name}}</li>
              <li @click="roleMaskShow('')" class="fl">+</li>
            </ul>
          </li>
          <li class="clearfix_">
            <div class="fl">
              <i>*</i>
              <span>手机：</span>
            </div>
            <span class="fl">{{userData.mobilePhone}}</span>
            <span class="fl" style="color:#2272c8;margin-left:5px;cursor: pointer;"><router-link tag="a" :to="{name:'modifyMobilePhone',query: {num:userData.mobilePhone}}">修改</router-link></span>
          </li>
          <li class="clearfix_">
            <div class="fl">
              <span style="line-height:42px;">邮箱：</span>
            </div>
              <input class="fl txt" type="text" v-model="mailbox">
            <!-- <span class="fl">{{userData.email?userData.email:'您的账号还没有绑定邮箱'}}</span>
            <span class="fl" style="color:#2272c8;margin-left:5px;">立即绑定</span> -->
          </li>
          <li class="clearfix_ height_">
            <div class="fl h_">
              <span>出生日期：</span>
            </div>
            <el-form class="fl" style="height:40px;">
              <el-form-item>
                <el-date-picker
                  v-model="time"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="getTime"
                  placeholder="">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </li>
          <li class="clearfix_">
            <div class="fl">
              <span>地址：</span>
            </div>
            <ul class="fl clearfix_">
              <li class="fl threeLevel">
                <p @click="boxShow(0)">{{province}}</p>
                <ul v-show="idx_0" class="child">
                  <li @click="choiceProvince(item.name,item.id)" v-for="(item,index) in provinceList" :key="index">{{item.name}}</li>
                </ul>
              </li>
              <li class="fl threeLevel">
                <p @click="boxShow(1)">{{city}}</p>
                <ul v-show="idx_1" class="child">
                  <li @click="choiceCity(item.name,item.id)" v-for="(item,index) in cityList" :key="index">{{item.name}}</li>
                </ul>
              </li>
              <li class="fl threeLevel">
                <p @click="boxShow(2)">{{county}}</p>
                <ul v-show="idx_2" class="child">
                  <li @click="choiceCounty(item.name,item.id)" v-for="(item,index) in countyList" :key="index">{{item.name}}</li>
                </ul>
              </li>
            </ul>
          </li>
          <li style="height:62px;" class="clearfix_">
            <div class="fl">
              <span>详情地址：</span>
            </div>
            <textarea class="fl address_" maxlength="50" v-model="address"></textarea>
          </li>
          <li class="clearfix_ verificationBox">
            <div class="fl">
              <span>验证：</span>
            </div>
            <input type="text" v-model="txtCodeVal" class="fl txt_code_val">
            <div class="fl txt_code"><img :src="txtCode" alt=""></div>
            <div @click="gettxtcode" class="fl get_code_btn">换一张</div>
            <!-- <div class="fl verification clearfix_">
              <div class="fl success_bg"></div>
              <div class="fl slide"></div>
              <div class="fl _slide"></div>
              <div class="fl t">请按住滑块拖到最右边</div>
            </div> -->
          </li>
          <li>
            <button @click="submit" class="mic_i_btn">保存</button>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="roleIsShow" class="information_mask">
      <div class="information_modify">
        <div class="information_title">修改信息</div>
        <div class="information_modify_content">
          <ul style="margin-top:28px;">
            <li class="clearfix_">
              <div class="fl">
                角色：
              </div>
              <input @change="changeRole(1002)" :checked="role==1002" class="fl sex" type="radio" name="role"><span class="fl">孕妈</span>
              <input @change="changeRole(1001)" :checked="role==1001" class="fl sex" type="radio" name="role"><span class="fl">宝宝</span>
            </li>
            <li v-show="role==1002" class="clearfix_">
              <div class="fl">
                <i>*</i> 孕周：
              </div>
              <input class="fl txt" type="text" v-model="gestationalAge">
            </li>
            <li v-show="role==1001" class="clearfix_">
              <div class="fl">
                <i>*</i> 出生日期：
              </div>
              <el-form class="fl" style="height:40px;">
                <el-form-item>
                  <el-date-picker
                    v-model="birthday"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="getBirthday"
                    placeholder="">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </li>
            <li v-show="role==1001" class="clearfix_">
              <div class="fl">
                宝宝乳名：
              </div>
              <input class="fl txt" type="text" v-model="babyName">
            </li>
            <li v-show="role==1001" class="clearfix_">
              <div class="fl">
                宝宝性别：
              </div>
              <input @change="changeBabyGender(1)" :checked="babyGender==1" class="fl sex" type="radio" name="babyGender"><span class="fl">男</span>
              <input @change="changeBabyGender(2)" :checked="babyGender==2" class="fl sex" type="radio" name="babyGender"><span class="fl">女</span>
            </li>
          </ul>
        </div>
        <div @click="updateRole" class="information_btn">{{roleId?'修改':'保存'}}</div>
        <div @click="roleMaskHide" class="information_title_off">×</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
// window.onload=function(){
//   var div1=$('.slide')
//   var div2=$('._slide')
//   var ifDown=false
//   var isOk=false
//   div1.mousedown(function(ev){
//     if(isOk)return
//     ifDown=true
//     var oldX=ev.clientX
//     var l
//     $(document).mousemove(function(ev){
//       if(ifDown){
//         l=ev.clientX-oldX
//         if(l<-1){
//           l=-1
//         }
//         if(l>$('.verification .t').width()){
//           l=$('.verification .t').width()
//         }
//         div1.css('left',l)
//         $('.success_bg').css('width',l)
//         if(l==$('.verification .t').width()){
//           $('.verification .t').html('')
//           $('.success_bg').html('验证通过')
//           $('.success_bg').css('color','#fff')
//           div1.hide()
//           div2.show()
//           isOk=true
//           // getApp().isOk=isOk
//         }
//       }
//     })
//     $(document).mouseup(function(){
//       ifDown=false
//       if(l!=$('.verification .t').width()){
//         div1.css('left',-1)
//         $('.success_bg').css('width',0)
//       }
//     })
//   })
  
// }

// $(document).bind('selectstart',function(){return false;});  
export default {
  data(){
    return {
      name:'',
      nickname:'',
      time:'',
      province:'--请选择--',
      provinceId:'',
      provinceList:[],
      city:'--请选择--',
      cityId:'',
      cityList:[],
      county:'--请选择--',
      countyId:'',
      countyList:[],
      idx_0:false,
      idx_1:false,
      idx_2:false,
      address:'',
      ifDrag:false,
      oldX:0,
      newLeft:'-1px',
      userData:{},
      timg:require('../../assets/img/niu.png'),
      gender:null,
      pic:'',
      memberUserImg:'',
      role:1002,
      babyGender:0,
      birthday:'',
      gestationalAge:'',
      babyName:'',
      roleIsShow:false,
      roleId:'',
      txtCode:'',
      txtCodeVal:'',
      mailbox:''
    }
  },
  mounted:function(){
    var t_=this
    t_.getArea(0,0)
    t_.getUserMember()
    t_.gettxtcode()
  },
  methods:{
    gettxtcode:function(){
      var t_=this
      var timestamp=Date.parse(new Date())
      var data0bj=Qs.stringify({
        t:timestamp
      })
      var xhrFields = {
        withCredentials: true
      }
      axios.post(
        `${ip}formWorkInterface/verifyCode`,data0bj,xhrFields
      ).then( res => {
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0)t_.txtCode='data:image/png;base64,'+res.data.pic
      } )
    },
    updateRole:function(id){
      var t_=this
      if(t_.role==1002){
        if(t_.gestationalAge=='')return t_.$message({
          message:'请填写孕周',
          center:true,
          type:'warning'
        })
        if(t_.gestationalAge>40)return t_.$message({
          message:'请填写正确的孕周',
          center:true,
          type:'warning'
        })
      }else{
        if(t_.birthday=='')return t_.$message({
          message:'请选择出生日期',
          center:true,
          type:'warning'
        })
      }
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:id,
        role:t_.role
      }
      if(t_.role==1002){
        data0bj.gestationalAge = t_.gestationalAge
      }else{
        data0bj.birthday = t_.birthday
        if (t_.babyName)data0bj.name = t_.babyName
        if (t_.babyGender)data0bj.babyGender = t_.babyGender
      }
      axios.post(`${ip}formWorkInterface/updateRole`,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.roleMaskHide()
          t_.getUserMember()
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    getRoleContent:function(id){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:id
      })
      axios.post(`${ip}formWorkInterface/getRoleContent`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.role=res.data.data.role
          if(res.data.data.role==1002){
            t_.gestationalAge=res.data.data.gestationalAge
          }else{
            t_.birthday=res.data.data.birthday
            t_.babyName=res.data.data.name
            t_.babyGender=res.data.data.babyGender
          }
        }
      })
    },
    roleMaskShow:function(id){
      var t_=this
      t_.roleId=''
      if(id)t_.getRoleContent(id),t_.roleId=id
      t_.gestationalAge=''
      t_.birthday=''
      t_.babyName=''
      t_.babyGender=0
      t_.roleIsShow=true
    },
    roleMaskHide:function(){
      var t_=this
      t_.roleIsShow=false
    },
    uploadHeadPortrait:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        pic:t_.memberUserImg
      })
      axios.post(`${ip}formWorkInterface/saveMemberIco`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:'上传头像成功！',
            center:true,
            type:'success'
          })
          t_.pic=res.data.picUrl
        }
      })
    },
    uploadMemberUserImg:function(e){
      var t_=this
      let file = e.target.files[0]
      let param = new FormData()
      param.append('file',file,file.name)
      param.append('channel',2)
      param.append('tamp',localStorage.tamp?localStorage.tamp:'')
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      }
      axios.post(`${ip}formWorkInterface/uploadImgIco`,param,config).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.memberUserImg=res.data.url
          t_.uploadHeadPortrait()
        }else{
          t_.$message({
            message:'上传图片失败，请重新上传',
            center:true,
            type:'warning'
          })
        }
      })
    },
    changeInput:function(n){
      var t_=this
      t_.gender=n
    },
    changeRole:function(n){
      var t_=this
      t_.role=n
    },
    changeBabyGender:function(n){
      var t_=this
      t_.babyGender=n
    },
    submit:function(){
      var t_=this
      if(t_.nickname=='')return t_.$message({
        message:'请输入昵称',
        center:true,
        type:'warning'
      })
      if(t_.gender==null)return t_.$message({
        message:'请选择性别！',
        center:true,
        type:'warning'
      })
      if((t_.name.length>15&&t_.name)||(t_.nickname.length>15&&t_.nickname))return t_.$message({
        message:'请输入15个以内的字符',
        center:true,
        type:'warning'
      })
      if(t_.mailbox){
        var re = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
        if (!re.test(t_.mailbox))return t_.$message({
          message:'邮箱输入有误',
          center:true,
          type:'warning'
        })
      }
      if(t_.txtCodeVal=='')return t_.$message({
        message:'请输入验证码',
        center:true,
        type:'warning'
      })
      if(t_.time)t_.time=t_.time.split('-').join('')
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        nickname: t_.nickname,
        name: t_.name,
        gender: t_.gender,
        county:t_.countyId,
        address:t_.address,
        birthday:t_.time,
        authCode:t_.txtCodeVal,
        email:t_.mailbox
      })
      var xhrFields = {
        withCredentials: true
      }
      axios.post(`${ip}formWorkInterface/updateMember`,data0bj,xhrFields).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          t_.$router.push({path:'/member'})
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
          t_.gettxtcode()
          t_.txtCodeVal=''
        }
      })
    },
    getUserMember:function(val){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        page:val,
        pagesize:18
      })
      axios.post(`${ip}formWorkInterface/memberInfo`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.userData=res.data.data
          t_.name=t_.userData.realName
          t_.nickname=t_.userData.name
          t_.gender=t_.userData.gender
          t_.pic=t_.userData.pic
          t_.time=t_.userData.birthday
          t_.address=t_.userData.address
          if(t_.userData.proId){
            t_.province=t_.userData.proName
            t_.provinceId=t_.userData.proId
            t_.getArea(t_.provinceId,0)
          }
          if(t_.userData.cityId){
            t_.city=t_.userData.cityName
            t_.cityId=t_.userData.cityId
            t_.getArea(t_.provinceId,t_.cityId)
          }
          if(t_.userData.countyId){
            t_.county=t_.userData.countyName
            t_.countyId=t_.userData.countyId
          }
        }
      })
    },
    choiceProvince:function(name,id){
      var t_=this
      t_.province=name
      t_.provinceId=id
      t_.getArea(t_.provinceId,0)
      t_.idx_0=false
    },
    choiceCity:function(name,id){
      var t_=this
      t_.city=name
      t_.cityId=id
      t_.getArea(t_.provinceId,t_.cityId)
      t_.idx_1=false
    },
    choiceCounty:function(name,id){
      var t_=this
      t_.county=name
      t_.countyId=id
      t_.idx_2=false
    },
    boxShow:function(idx){
      var t_=this
      if(idx==0){
        if(t_.idx_0){
          t_.idx_0=false
        }else{
          t_.idx_0=true
        }
      }else if(idx==1){
        if(t_.province=='--请选择--')return
        if(t_.idx_1){
          t_.idx_1=false
        }else{
          t_.idx_1=true
        }
      }else if(idx==2){
        if(t_.city=='--请选择--')return
        if(t_.idx_2){
          t_.idx_2=false
        }else{
          t_.idx_2=true
        }
      }
    },
    getTime:function(val){
      this.time=val
    },
    getBirthday:function(val){
      this.birthday=val
    },
    getArea:function(id1,id2){
      var t_=this
      var data=Qs.stringify({
        province:id1,
        city:id2,
        tamp:localStorage.tamp?localStorage.tamp:''
      })
      axios.post(`${ip}formWorkInterface/getArea`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.status==1){
            t_.provinceList=res.data.results
          }else if(res.data.status==2){
            t_.cityList=res.data.results
          }else if(res.data.status==3){
            t_.countyList=res.data.results
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  .mic_i li>.txt_code{
    width: 80px;
    margin-left: 15px;
    margin-top: 6px;
  }
  .mic_i li>.txt_code_val{
    width: 78px;
    height: 28px;
    border:1px solid #dcdfe6;
    padding-left: 6px;
    line-height: 28px;
    margin-top: 6px;
    border-radius: 5px;
  }
  .mic_i li>.get_code_btn{
    width: 40px;
    text-align: left;
    line-height: 30px;
    margin-left: 10px;
    margin-top: 6px;
    cursor: pointer;
  }
  .member_information_box{
    width: 1068px;
    border: 1px solid #ddd;
    background: #fff;
  }
  .member_information_title{
    height: 38px;
    line-height: 38px;
    font-size:16px;
    font-weight: 900;
    background: #fafafa;
    padding-left: 10px;
  }
  .mic_pic{
    width: 131px;
    margin: 0 90px;
    height: 155px;
    padding-top: 30px;
    margin-bottom: 30px;
  }
  .mic_pic_box{
    width: 125px;
    height: 125px;
    border: 3px solid #e3e3e3;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 20px;
    position: relative;
  }
  .mic_pic_box img{
    width: 125px;
    height: 125px;
  }
  .mic_pic_box .img_btn{
    width: 125px;
    height: 125px;
    position: absolute;
    top:0;
    left:0;
    opacity: 0;
  }
  .mic_pic_username input{
    width: 145px;
    height: 24px;
    border: 1px solid #bbb;
    padding-left: 5px;
    margin-top:35px;
  }
  /* .mic_i{
    padding: 0 90px;
  } */
  .mic_i>ul>li{
    height: 40px;
    margin-left: 45px;
    margin-bottom: 15px;
  }
  .mic_i .information_role{
    margin-top: 8px;
  }
  .mic_i .information_role>li{
    padding: 5px 10px;
    border: 1px solid #dd2c3a;
    border-radius: 5px;
    margin-right: 10px;
    cursor: pointer;
  }
  .mic_i .height_{
    height: 40px;
  }
  .mic_i li>div{
    width: 70px;
    text-align: right;
  }
  .mic_i li i{
    color: #dd2c3a;
  }
  .mic_i li span{
    line-height: 26px;
  }
  .mic_i li .h_{
    line-height: 40px;
  }
  .mic_i li .txt{
    width: 215px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    padding-left: 5px;
  }
  .mic_i li .sex{
    margin-top: 8px;
    margin-left: 10px;
    margin-right: 5px;
  }
  .mic_i .threeLevel{
    width: 80px;
    height: 26px;
    border: 1px solid #bbb;
    text-align: center;
    margin-left: 0;
    margin-right: 10px;
    position: relative;
    margin-bottom: 0;
  }
  .mic_i .threeLevel p{
    cursor: pointer;
    line-height: 26px;
  }
  .mic_i .threeLevel .child{
    position: absolute;
    border: 1px solid #bbb;
    width: 80px;
    top: 26px;
    left: -1px;
    background: #fff;
    height: 150px;
    overflow-y: auto;
    z-index: 100;
  }
  .mic_i .threeLevel .child li{
    text-align: center;
    line-height: 26px;
    margin: 0;
    cursor: pointer;
  }

  .mic_i .address_{
    width: 257px;
    height: 60px;
    border: 1px solid #ccc;
    font-size: 12px;
    border-radius: 3px;
    padding-left: 8px;
  }
  .mic_i .verificationBox{
    height: 42px;
  }
  .mic_i .verificationBox span{
    line-height: 42px;
  }
  .mic_i .verification{
    width: 330px;
    height: 40px;
    background: #e8e8e8;
    border: 1px solid #ddd;
    position: relative;
  }
  .mic_i .verification .slide{
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    background: #fff url(../../assets/img/arrow_db.png) no-repeat center;
    position: absolute;
    top: -1px;
    left: -1px;
    cursor: pointer;
    z-index: 99;
  }
  .mic_i .verification ._slide{
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    background: #fff url(../../assets/img/complete_1.png) no-repeat center;
    position: absolute;
    top: -1px;
    left: 289px;
    cursor: pointer;
    z-index: 999;
    display: none;
  }
  .verification .success_bg{
    width: 0;
    height: 40px;
    background: #7fc72b;
    text-align: center;
    line-height: 40px;
    color: #999;
  }
  .mic_i .verification .t{
    width: 289px;
    height: 40px;
    text-align: center;
    position: absolute;
    top:0;
    left:41px;
    color:#999;
    line-height: 40px;
    font-size: 14px;
  }
  .mic_i_btn{
    width: 77px;
    height: 30px;
    background: #dd2c3a;
    border-radius: 5px;
    border: 0;
    color: #fff;
    margin-left: 70px;
    cursor: pointer;
  }
  .information_mask{
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
    z-index: 1001;
  }
  .information_modify{
    width: 579px;
    height: 430px;
    background:#fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform:translate(-50%,-50%);
    -moz-transform:translate(-50%,-50%);
    -o-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
  }
  .information_title{
    background:#f5f3f4;
    height: 44px;
    line-height: 44px;
    color:#757472;
    font-size: 16px;
    text-align: center;
  }
  .information_title_off{
    position: absolute;
    top:10px;
    right:10px;
    width: 20px;
    height:20px;
    line-height: 20px;
    font-size:18px;
    color:#757472;
    text-align: center;
    cursor: pointer;
  }
  .information_modify_content li{
    margin-bottom: 20px;
  }
  .information_modify_content div{
    width: 220px;
    text-align: right;
    color:#333;
    height: 34px;
    line-height: 34px;
    font-size:16px;
    margin-right: 15px;
  }
  .information_modify_content span{
    font-size:16px;
    color:#0f0f0f;
    line-height: 34px;
    margin-right: 10px;
  }
  .information_modify_content input[type=radio]{
    margin-top: 11px;
    margin-right: 10px;
  }
  .information_modify_content input[type=text]{
    width: 210px;
    height: 32px;
    border:1px solid #d2d2d2;
    border-radius: 5px;
    padding-left: 8px;
  }
  .information_modify_content i{
    color:#dd2c3a;
  }
  .information_btn{
    width: 94px;
    height: 34px;
    background: #dd2c3a;
    text-align: center;
    line-height: 34px;
    color:#fff;
    position: absolute;
    left: 50%;
    margin-left: -47px;
    bottom: 50px;
    border-radius: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/information.vue